import { create } from "zustand";
import { getAllVendorFunction } from "../api/vendor";


export const useVendorStore = create((set, get) => ({
    vendor: [],
    loading: false,
    selectedVendor: null,
    nonPaginatedVendor: [],

    getAllVendor: async (pageNumber, pageSize, search, field) => {
        set({ loading: true })
        try {
            const res = await getAllVendorFunction(pageNumber, pageSize, search, field)
            set({ loading: false, vendor: res?.ref })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    }
}))